












































































































































































































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import { Relocation } from '@/dto';
import {
    TableConfig,
    columnTemplates,
    getModifiedItems,
    Table,
    defaultTableConfig,
} from '@/core/components/table';
import DataSource from 'devextreme/data/data_source';
import {
    DxDataGrid,
    DxColumn,
    DxSelection,
    DxEditing,
} from 'devextreme-vue/data-grid';
import { ContextsState } from '@/store';
import {
    CONTRACTS,
    Events,
    FetchServiceContract,
    EventsServiceContract,
    WindowsServiceContract,
} from '@/core/contracts';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import { MicroeconomicsPageArgs } from '../microeconomics';
import { duration } from '@/core/filters/duration';

@Component({
    components: {
        DxDataGrid,
        DxColumn,
        DxSelection,
        DxEditing,
    },
})
export default class RelocationsTable extends Vue {
    @Prop({ type: String, required: true }) private tableKey!: string;
    @Prop({ type: [Array, Object], required: true })
    private dataSource!: DataSource;

    @Inject(CONTRACTS.WindowsService)
    private _windowsService?: WindowsServiceContract;
    @Inject(CONTRACTS.FetchService)
    private _fetchService?: FetchServiceContract;
    @Inject(CONTRACTS.EventsService)
    private _eventsService?: EventsServiceContract;

    private currentTime = new Date(ContextsState.current!.currentTime);

    public get defaultTableConfig(): Partial<TableConfig> {
        return defaultTableConfig(this);
    }

    public get columnTemplates() {
        return columnTemplates;
    }

    public async mounted() {
        this._eventsService!.on(
            Events.ProcessingFinished,
            this.onProcessingFinished
        );
    }

    public async beforeDestroy() {
        this._eventsService!.off(
            Events.ProcessingFinished,
            this.onProcessingFinished
        );
    }

    public showRoutes(data: any) {
        if (data.data.routeSourcesCount > 1) {
            this._windowsService!.update('microeconomics-page', {
                packAlias: data.data.packAlias,
                direction: 'In',
            } as MicroeconomicsPageArgs);
        } else {
            this._windowsService!.update('microeconomics-details-page', {
                packAlias: data.data.packAlias,
                direction: 'In',
                routeIndex: 0,
            } as MicroeconomicsPageArgs);
        }
    }

    public getDataGridInstance(): Table {
        const element = this.$refs['data-grid'] as unknown;
        return (element as DxDataGrid).instance!;
    }

    public onRowUpdated(args: { key: any }) {
        this.getDataGridInstance().selectRows([args.key], true);
    }

    public getSelectedItems() {
        return getModifiedItems<Relocation>(this.getDataGridInstance());
    }

    public setImportantDemandFlag(items: Relocation[], important: boolean) {
        const data = items.map(item => ({
            packId: item.packId,
            important,
        }));

        const currentContextId = ContextsState.currentContextId;
        this._fetchService!.post(
            `/contexts/${currentContextId}/edit-consumptions`,
            data
        ).then(() => {
            items.forEach(item => (item.important = important));
        });
    }

    private relocationTime(rowData: any) {
        const start = new Date(rowData.start);
        start.setMinutes(-this.currentTime.getTimezoneOffset());
        return duration(this.currentTime, start);
    }

    private onProcessingFinished = ({ contextId }: any) => {
        if (Number(ContextsState.currentContextId) === Number(contextId)) {
            this.getDataGridInstance().refresh();
        }
    };

    private toggleImportantDemand(item: Relocation) {
        this.setImportantDemandFlag([item], !item.important);
    }
}
